import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-quantity-selector',
  templateUrl: './quantity-selector.component.html',
  styleUrls: ['./quantity-selector.component.scss'],
})
export class QuantitySelectorComponent implements OnInit {
  // public value: number = 0;

  @Input() min: number = 0;
  @Input() max: number = Number.MAX_SAFE_INTEGER;
  @Input() value: number = 0;
  @Input() disabled: boolean = false;
  @Input() isCompact: boolean = false;
  @Input() isVertical: boolean = false;

  @Output() valueChanged = new EventEmitter<number>();
  @Output() valueIncreased = new EventEmitter<number>();
  @Output() valueDecreased = new EventEmitter<number>();

  constructor() {}

  ngOnInit() {
    // this.value = this.value;
    return;
  }

  onDecrease(): void {
    if (this.disabled) {
      return;
    }
    if (this.value === this.min) {
      return;
    }
    this.value--;
    this.valueChanged.next(this.value);
    this.valueDecreased.next(this.value);
  }

  onIncrease(): void {
    if (this.disabled) {
      return;
    }
    if (this.value === this.max) {
      return;
    }
    this.value++;
    this.valueChanged.next(this.value);
    this.valueIncreased.next(this.value);
  }
}
